
import { useProtectedAPI } from "./apiService";
import useSWR from "swr";




export const useGetTopic = () => {
    const protectedAPI = useProtectedAPI()
    /* const controller = new AbortController();*/ 

    const getTopic = async (forum_id, topic_id) => {
        const url = `/forums/${forum_id}/topics/${topic_id}`
        const response = await protectedAPI.get(url)
        /*const response = await protectedAPI.get(url, {signal: controller.signal})
        controller.abort(); */
        return response.data
    }
    
    return getTopic
}



export const useGetTopicsSWR = (forum_id, topic_id) => {
    const protectedAPI = useProtectedAPI()
    const fetcher = (url) => protectedAPI.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR( (forum_id && topic_id) ? `/forums/${forum_id}/topics/${topic_id}` : null, fetcher, {refreshInterval: 60 * 1000, refreshWhenHidden: true});

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useCreateTopic= () => {
    const protectedAPI = useProtectedAPI();

    const createTopic = async (forum_id, data) => {
        const response = await protectedAPI.post(`/forums/${forum_id}/topics`, data)
        return response.data
    };

    return createTopic;
}



export const useDeleteTopic = () => {
    const protectedAPI = useProtectedAPI();

    const deleteTopic = async (forum_id, topic_id) => {
        const response = await protectedAPI.delete(`/forums/${forum_id}/topics/${topic_id}`)
        return response.data
    };

    return deleteTopic;
}



export const useUpdateTopic = () => {
    const protectedAPI = useProtectedAPI();

    const updateTopic = async (forum_id, topic_id, data) => {
        const response = await protectedAPI.put(`/forums/${forum_id}/topics/${topic_id}`, data)
        return response.data
    };

    return updateTopic;
}